import React from 'react'

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableRowCell,
  TableRowCellBold
} from './styles'
import { tableConfig } from './data.json'

const Index = ({ data }) => {
  const { columns } = tableConfig

  return (
    <Table>
      <TableHeader>
        {columns.map((column, index) => (
          <TableHeaderCell key={`request-file-header-${index}`} {...column}>
            {column.header}
          </TableHeaderCell>
        ))}
      </TableHeader>
      {data.map((row, index) => (
        <TableRow key={`request-file-body-${index}`} index={index}>
          <TableRowCell {...columns[0]}>{row.date}</TableRowCell>
          <TableRowCell {...columns[1]}>{row.hour}</TableRowCell>
          <TableRowCellBold {...columns[2]}>{row.fileType}</TableRowCellBold>
          <TableRowCell {...columns[3]}>{row.sequential}</TableRowCell>
          <TableRowCellBold {...columns[4]}>{row.status}</TableRowCellBold>
        </TableRow>
      ))}
    </Table>
  )
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/ec/RequestFile/table/index.js